const SECURE_NOTE_DISCLAIMER_TEXT =
  'We keep your sensitive info safe and sound, using top-notch encryption and strict access rules. ' +
  '- only our trained copilots get a peek.';

export { SECURE_NOTE_DISCLAIMER_TEXT };
